@if (state.open && sanitizedUrl()) {
  <div
    class="__code-server-overlay"
    [class.is-minimized]="overlay.minimized()"
    [class.is-maximized]="overlay.maximized()"
    [class.is-detached]="state.isDetached"
    [style.top.px]="overlay.maximized() ? null : overlay.position()?.top"
    [style.left.px]="overlay.maximized() ? null : overlay.position()?.left"
    [style.width.px]="(overlay.maximized() || state.isDetached) ? null : overlay.position()?.width"
    [style.height.px]="(overlay.maximized() || state.isDetached) ? null : overlay.position()?.height"
    [style.right.px]="(overlay.maximized() || !state.isDetached) ? null : detachedInset()?.right"
    [style.bottom.px]="(overlay.maximized() || !state.isDetached) ? null : detachedInset()?.bottom">

    <iframe
      #codeServerIframe
      [src]="sanitizedUrl()"
      frameborder="0"
      allow="clipboard-read; clipboard-write">
    </iframe>

    <div class="__overlay-controls">
      <button
        mat-icon-button
        class="__overlay-btn"
        (click)="onMinimize$.next()">
        <mat-icon fontSet="material-icons-outlined">minimize</mat-icon>
      </button>

      @if (overlay.maximized()) {
        <button
          mat-icon-button
          class="__overlay-btn"
          (click)="onUnmaximize$.next()">
          <mat-icon fontSet="material-icons-outlined">close_fullscreen</mat-icon>
        </button>
      } @else {
        <button
          mat-icon-button
          class="__overlay-btn"
          (click)="onMaximize$.next()">
          <mat-icon fontSet="material-icons-outlined">open_in_full</mat-icon>
        </button>
      }

      <button
        mat-icon-button
        class="__overlay-btn __overlay-btn--close"
        (click)="onClose$.next()">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>
  </div>
}
